import Alpine from 'alpinejs'

Alpine.store('officeMembership', {
  type: '',

  toggle(type: string) {
    this.type = type
  },
})
